/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 云剧院视频播放日志
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  videoPlayLogRequest: cloundtheater.videoPlayLogRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cloundtheater/video/play/log`,
    data: videoPlayLogRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
